<!-- 页脚导航 -->
<template>
<div>
	<div class="footer">
		<div class="container foot_box">
			<dl class="dl_fir fl">
				<dt>ABOUT US</dt>
				<dd>
					<a @click="toLink(1)">NEWS</a>
					<a @click="toLink(2)">COMPANY PROFILE</a>
					<a @click="toLink(3)">ABOUT LUARA</a>
					<a @click="toLink(0)">ABOUT HOCTIME</a>
					<a @click="toLink(4)">BRAND CONSULTANT</a>
				</dd>
			</dl>
			<dl class="dl_sed fl">
				<dt>PRODUCT CENTER</dt>
				<dd>
					<a @click="toLink(5)">LUARA</a>
					<a @click="toLink(6)">HOC TIME</a>
					<a @click="toLink(7)">MAESOUL</a>
					<a @click="toLink(8)">LEWA</a>
					<a @click="toLink(9)">SLIM BEAUTY LABO</a>
					<a @click="toLink(10)">COMING SOON</a>
				</dd>
			</dl>
			<dl class="dl_thir fl" style="width: 160px;">
				<dt>HELP CENTER</dt>
				<dd>
					<a @click="toLink(11)">CONTACT US</a>
					<!-- <a @click="toLink(12)">APP</a> -->
					<a @click="toLink(13)">TA</a>
				</dd>
			</dl>
			<dl class="dl_four fr">
				<dt>FOLLOW  US</dt>
				<dd>
					<li class="ico_1">
						<div class="ewm_box ewm_box1">
							<img src="static/picture/ewm.jpg">
							<p>扫一扫 关注我们</p>
						</div>
					</li>
					<li><a class="ico_2" href="https://weibo.com/u/6501704747"></a></li>
					<li class="ico_3">
						<div class="ewm_box ewm_box3">
							<img src="static/picture/ewm2.jpg">
						</div>
					</li>
				<li><a class="ico_4" href="https://luara.tmall.com/"></a></li>
				</dd>
			</dl>
		</div>
	</div>
	<div class="copyright">
		<p>日运（福建）贸易有限公司 </p>
		<p>地址：福建省福州市闽侯县南屿镇乌龙江南大道55号龙旺商业中心1#楼19层</p>
	</div>
  <div class="copyright">
  	<p><a style="color: #333; margin-left: 20px;" href="https://beian.miit.gov.cn">闽ICP备18009858号-1</a></p>
  </div>
</div>

</template>

<script>
  export default {
    name: 'FooterNav',
    props: [],
    data() {
      return {

      };
    },
    methods: {
      toLink(nav) {
        // this.$emit('changeNav', data);
		if(nav==0){
 			this.$router.push({ path: '/AboutHocTime', query:{ } })
		}
		if(nav==1){
 			this.$router.push({ path: '/News', query:{ } })
		}
		if(nav==2){
 			this.$router.push({ path: '/Company', query:{ } })
		}
		if(nav==3){
 			this.$router.push({ path: '/About', query:{ } })
		}
		if(nav==4){
 			this.$router.push({ path: '/CONSULTANT', query:{ } })
		}
		if(nav==5){
 			this.$router.push({ path: '/LUARA', query:{ } })
		}
		if(nav==6){
 			this.$router.push({ path: '/HOCTIME', query:{ } })
		}
		if(nav==7){
 			this.$router.push({ path: '/MAESOUL', query:{ } })
		}
		if(nav==8){
 			this.$router.push({ path: '/BRAND_UPGRADING', query:{ } })
		}
		if(nav==9){
 			this.$router.push({ path: '/NEW_ARRIVIAL', query:{ } })
		}
		if(nav==10){
 			this.$router.push({ path: '/COMING_SOON', query:{ } })
		}
		if(nav==11){
 			this.$router.push({ path: '/CONTACT', query:{ } })
		}
		if(nav==12){
 			this.$router.push({ path: '/APP', query:{ } })
		}
		if(nav==13){
 			this.$router.push({ path: '/TA', query:{ } })
		}
      },
    },
  };
</script>

<style scoped>
/*底部*/
.footer{

	background: #f6f6f6;
	padding: 50px 0 30px;
}
.foot_box{
	display: table;
}
.footer dl {
	width: calc((100% - 173px)/3);
	text-align: left;
}
.footer dt {
	font-size: 20px;
	letter-spacing: 2px;
	color: #000;
	font-family: Font_Medium;
	margin-bottom: 20px;
	font-weight: normal;
}
.footer dd a {
	display: block;
	overflow: hidden;
	padding: 10px 0;
	letter-spacing: 2px;
	font-size: 16px;
	color: #000000;
	font-family: Font_Light;
	cursor: pointer;
}

.footer .dl_sed dd a {
	letter-spacing: 0;
	text-transform: uppercase;
}

.footer .dl_four {
	width: 250px;
}
.footer .dl_four li{
	float: left;
	width: 47px;
	height: 47px;
	margin-right: 16px;
	position: relative;
}
.footer .dl_four li:last-child{
	margin-right: 0;
}
.footer .dl_four a{
	display: block;
	width: 47px;
	height: 47px;
	padding: 0;
}
.footer .dl_four .ico_1{
	background: url(../../static/image/foot_ico_1.png) no-repeat 0px 0px;
}

.footer .dl_four .ico_2{
	background: url(../../static/image/foot_ico_2.png) no-repeat 0px 0px;
}

.footer .dl_four .ico_3{
	background: url(../../static/image/foot_ico_3.png) no-repeat 0px 0px;
}
.footer .dl_four .ico_4{
	background: url(../../static/image/foot_ico_4.png) no-repeat 0px 0px;
}
.footer .dl_four li .ewm_box{
	width: 160px;
	opacity: 0;
	text-align: center;
	position: absolute;
	bottom: 57px;
    left: 50%;
    margin-left: -80px;
	border-radius: 10px;
	border: 1px solid #626262;
	background: #fff;
	font-size: 14px;
	color: #303133;
	overflow: hidden;
}
.footer .dl_four li.ico_1:hover .ewm_box1,
.footer .dl_four li.ico_3:hover .ewm_box3{
	opacity: 1;
}
.footer .dl_four li .ewm_box img{
	max-width: 100%;
}
.footer .dl_four li.ico_1:hover:before,
.footer .dl_four li.ico_3:hover:before{
	content: "";
	display: block;
	position: absolute;
	left: 50%;
	margin-left: -10px;
	bottom: 47px;
	width: 20px;
	height: 10px;
	border-left: 10px solid transparent;
    border-right: 10px solid transparent;
    border-top: 10px solid #626262;
	z-index: 2;
}

.copyright{
	text-align: center;
	font-size: 14px;
	color: #999999;
	background: #fff;
	padding: 20px 0 30px;
}
/*底部结束*/


</style>



// WEBPACK FOOTER //
// src/components/FooterNav.vue